export const translations = {
  en: {
    // Language Selection Screen
    selectLanguage: 'Select Language',
    // Start Screen
    start: 'START',
    loading: 'LOADING...',
    version: 'Version',
    // Home Screen
    monthlyFeatured: 'Monthly Featured Comic',
    featuredDescription: "New exclusive content every month! Don't miss out.",
    promoMasterTier: 'New comic available NOW for Master Tier',
    promoLimitedAccess: 'limited access',
    promoPublicRelease: 'Public release next month',
    promoSeeItNow: 'Do you want to see it now?',
    bannerTodorokiText: 'New monthly comic, only available for Master Tier members.',
    bannerUnderfootText: 'New original comic in progress — a new adventure is about to begin at Footparadise.',
    bannerTanjiroText: 'May on Patreon — Tanjiro faces a challenge unlike any demon he has ever fought. 🔥',
    bannerKidText: 'May on Patreon — Eustass Kid finally claims his prize. A pirate captain always gets what he wants. ⚡',
    bannerCellText: 'May on Patreon — Cell has been hiding his true self all along. Time to reveal everything. 💪',
    bannerMogariText: 'May on Patreon — Mogari from Phantom Busters makes his debut. A new favorite is born! 👻',
    bannerTaiyoText: 'May on Patreon — Taiyo from Yozakura Family is in the mood to play. Do not keep him waiting! 🌸',
    bannerLangrisText: 'May on Patreon — The king is on his throne, and he has a very special reward waiting for you. 👑',
    bannerPromo1Text: 'Now on Patreon — The comic that started it all. Nakamura & Hirose, our very first release, is available now for Master Tier members. 🎓',
    bannerPromo2Text: 'Now on Patreon — My Hero Academia, chapter 4 and the grand finale. Part one of the last chapter is here. Master Tier only! 💥',
    comicLibrary: '📚 Comic Library',
    searchComics: 'Search comics...',
    browseCollection: 'Browse our complete collection. Rate each comic and see the best ones in Top Rated!',
    topRated: '🏆 Top Rated',
    topRatedDescription: 'Highest rated by our community',
    beFirstToRate: 'Be the first to rate!',
    tapToRefresh: 'Tap to refresh',
    unlock: 'UNLOCK',
    unlocked: 'UNLOCKED!',
    buy: 'Buy',
    free: 'Free',
    readFree: 'Read Free',
    enterCode: 'Enter code',
    incorrectCode: 'Incorrect code',
    ok: 'OK',
    lockAllConfirm: 'Are you sure you want to lock all comics? You will need to enter the unlock code again.',
    // Menu
    myCollection: 'My Collection',
    news: 'News',
    readOnPC: 'Read on PC',
    backup: 'Backup',
    patreon: 'Patreon',
    store: 'Store',
    storeLoadError: 'Could not load store',
    storeLoadErrorDesc: 'The store could not be loaded. Try opening it in your browser.',
    openInBrowser: 'Open in Browser',
    loading: 'Loading',
    // Patreon Page
    visitPatreon: 'Visit Our Patreon',
    patreonDescription: 'Support us on Patreon to get exclusive content, early access to new comics, and behind-the-scenes updates!',
    openPatreon: 'Open Patreon',
    exclusiveComics: 'Exclusive Comics',
    earlyAccess: 'Early Access',
    community: 'Community',
    specialRewards: 'Special Rewards',
    patreonNote: 'Tap the button above to visit our Patreon page',
    commissions: 'Commissions',
    updates: 'Updates',
    infoCredits: 'Info & Credits',
    signOut: 'Sign Out',
    // My Collection Page
    noComicsYet: 'No Comics Yet',
    noComicsDescription: "You haven't unlocked any comics yet. Go back to the home screen and unlock some comics to see them here!",
    browseComics: 'Browse Comics',
    yourUnlockedComics: '✨ Your Unlocked Comics ✨',
    comicsInCollection: 'comic(s) in your collection',
    pages: 'pages',
    readNow: 'Read Now',
    // Comic Viewer
    comicNotFound: 'Comic not found',
    comicNotFoundDesc: "The comic you're looking for doesn't exist",
    comicLocked: 'Comic Locked',
    comicLockedDesc: 'You must unlock this comic to view it',
    backToHome: 'Back to home',
    close: 'Close',
    prev: '← Prev',
    next: 'Next →',
    // Backup Page
    backupRestore: 'Backup & Restore',
    yourUnlockedComicsBackup: 'Your Unlocked Comics',
    backupDescription: 'Export your unlocked comics list to save it, or import a backup to restore your collection.',
    backupWarning: "The backup only saves which comics you've unlocked, not the comics themselves.",
    export: 'Export',
    import: 'Import',
    saving: 'Saving...',
    backupSavedDownloads: '✅ Backup saved to Downloads folder!',
    backupSavedDocuments: '✅ Backup saved to Documents folder!',
    backupSavedApp: '✅ Backup saved! Check app folder.',
    backupSavedSuccess: '✅ Backup saved successfully!',
    backupExported: '✅ Backup exported successfully!',
    backupError: '❌ Error exporting backup: ',
    restoredComics: '✅ Restored comic(s)!',
    invalidBackup: '❌ Invalid backup file format',
    couldNotReadBackup: '❌ Could not read backup file',
    importError: '❌ Error importing backup',
    backupHint: '📁 Backup will be saved to your Downloads folder',
    // Commissions Gallery
    commissionsCompleted: 'Commissions Completed',
    commissionsGallerySubtitle: 'A showcase of custom artwork created for our clients. Each piece represents a unique vision brought to life!',
    filterAll: 'All',
    filterIllustration: 'Illustrations',
    totalCommissions: 'Total artworks',
    // Read on PC Page
    howToReadOnPC: 'How to Read on PC',
    localServerMode: 'Local Server Mode - No internet required!',
    step1: 'Make sure your phone and computer are on the same Wi-Fi network',
    step2: 'Tap Start below to enable PC access',
    step3: 'Open the link shown below on your computer browser',
    step4: 'Enjoy your comics on a bigger screen!',
    pcImportant: 'Important:',
    pcKeepOpen: 'Keep this app open while reading on your PC. The connection will be lost if you close the app.',
    pcReaderActive: 'PC Reader Active',
    openURLOnPC: 'Open this URL on your PC:',
    comicsAvailable: 'comic(s) available',
    noComicsUnlocked: "You haven't unlocked any comics yet. Unlock some comics first to read them on PC.",
    disconnect: 'Disconnect',
    pleaseWait: 'Please wait...',
    disconnectHint: 'Tap "Disconnect" when you\'re done reading',
    // Info & Credits Page
    premiumCollection: 'Premium Comic Art Collection',
    aboutUs: 'About Us',
    aboutUsText: "Welcome to FootParadise! We are a passionate team of artists dedicated to creating unique and high-quality comic content for our amazing community. Our mission is to bring you exclusive artwork and stories that you won't find anywhere else.",
    connectWithUs: 'Connect With Us',
    connectText: 'Stay updated with our latest releases, behind-the-scenes content, and exclusive announcements by following us on social media!',
    officialWebsite: 'Official Website',
    support: 'Support',
    supportText: 'Love our work? Consider supporting us on Patreon to get early access to new comics, exclusive content, and help us continue creating amazing art for you!',
    credits: 'Credits',
    artStory: 'Art & Story',
    appDevelopment: 'App Development',
    allRightsReserved: 'All rights reserved.',
    // Commissions Page
    customArtwork: 'Custom Artwork',
    commissionsAccepted: 'Comic and illustration commissions are accepted! Get your own personalized artwork.',
    askWithoutCommitment: 'Feel free to ask without any purchase commitment.',
    selectCommissionType: 'Select Commission Type',
    comic: 'Comic',
    illustration: 'Illustration',
    numberOfCharacters: 'Number of Characters',
    details: 'Details',
    comicPlaceholder: 'Describe your comic: story, characters, number of pages, style preferences, etc.',
    illustrationPlaceholder: 'Describe your illustration: characters, poses, scenario, references, etc.',
    patreonUsername: 'Patreon Username (Master tier only - 20% OFF)',
    patreonUsernamePlaceholder: 'Your Patreon username (optional)',
    masterTierDiscount: '20% OFF for Patreon Master tier!',
    comicNoDiscount: 'Comics are not eligible for Patreon discount',
    yourContactEmail: 'Your Contact Email',
    emailPlaceholder: 'your.email@example.com',
    openingEmail: 'Opening Email...',
    sendCommissionRequest: 'Send Commission Request',
    emailDisclaimer: 'This will open your email app with the commission details pre-filled.',
    pleaseSelectType: 'Please select a commission type',
    pleaseProvideDetails: 'Please provide details for your commission',
    pleaseProvideEmail: 'Please provide your contact email',
    sending: 'Sending...',
    messageSentSuccess: 'Message sent successfully! We will contact you soon.',
    messageSentError: 'Error sending message. Please try again.',
    formspreeDisclaimer: 'Your message will be sent directly to our team.',
    // App Updates Page
    appUpdatesTitle: 'App Updates',
    downloadLatest: 'Download Latest Version',
    downloadAPK: 'Download APK',
    downloadApp: 'Download App',
    downloading: 'Downloading...',
    appUpdatesDescription: 'Download our exclusive app to access all artwork, receive notifications about new content, and enjoy a seamless browsing experience on your mobile device.',
    // News Page
    pullToRefresh: 'Pull to refresh',
    releaseToRefresh: 'Release to refresh',
    loadingImages: 'Loading images...',
    loadingUpdates: 'Loading updates...',
    loadingLargeImages: 'Loading large images, please wait...',
    wifiTip: 'Tip: A good WiFi connection helps load faster',
    gettingContent: 'Getting the latest content for you',
    // Settings Page
    settings: 'Settings',
    language: 'Language',
    languageDescription: 'Choose your preferred language for the app interface.',
    visual: 'Visual',
    visualDescription: 'Customize the appearance of the app.',
    darkMode: 'Dark Mode',
    discreteMode: 'Discrete Mode',
    discreteModeHint: 'Blur comic covers',
    sound: 'Sound',
    soundDescription: 'Enable or disable sound effects in the app.',
    soundOn: 'Sound On',
    soundOff: 'Sound Off',
    // Security
    security: 'Security',
    securityDescription: 'Protect your app with PIN or biometric.',
    pinHint: '4-digit security code',
    biometric: 'Fingerprint',
    biometricHint: 'Use fingerprint to unlock',
    lockOptions: 'Lock Options',
    lockOnOpen: 'Lock when app opens',
    lockAfterInactivity: 'Lock after inactivity',
    inactivityMinutes: 'Minutes of inactivity',
    createPin: 'Create PIN',
    confirmPin: 'Confirm PIN',
    enterNewPin: 'Enter a 4-digit PIN',
    reenterPin: 'Re-enter your PIN to confirm',
    pinMismatch: 'PINs do not match',
    back: 'Back',
    enterPinToUnlock: 'Enter your PIN to unlock',
    incorrectPin: 'Incorrect PIN',
    useBiometric: 'Use fingerprint',
    biometricReason: 'Verify your identity',
    biometricSubtitle: 'Use biometric to unlock',
    biometricSetup: 'Verify to enable biometric',
    forgotPin: 'Forgot PIN?',
    resetApp: 'Reset App',
    resetWarning: 'This will delete ALL your data including unlocked comics, settings, and your PIN. This action cannot be undone!',
    typeDeleteConfirm: 'Type BORRAR to confirm:',
    typeDeleteToConfirm: 'Type BORRAR to confirm',
    verifyPin: 'Verify PIN',
    enterCurrentPin: 'Enter your current PIN to disable security',
    // Master Access
    advancedAccess: 'Advanced Access',
    masterOnlyText: 'This option is only for active Master members.',
    cancel: 'Cancel',
    continue: 'Continue',
    enterMasterCode: 'Enter Master Code',
    activate: 'Activate',
    accessGranted: 'Access Granted!',
    allComicsUnlocked: 'All comics have been unlocked.',
    invalidCode: 'Invalid code. Please try again.',
    // Free Comics Section
    freeComicsSection: 'Vegeta: The paradise in his feet',
    freeComicsDescription: 'Enjoy these free comics! No unlock code needed. (English only)',
    readFree: 'Read Free'
  },
  es: {
    // Language Selection Screen
    selectLanguage: 'Seleccionar Idioma',
    // Start Screen
    start: 'INICIAR',
    loading: 'CARGANDO...',
    version: 'Versión',
    // Home Screen
    monthlyFeatured: 'Cómic Destacado del Mes',
    featuredDescription: '¡Nuevo contenido exclusivo cada mes! No te lo pierdas.',
    promoMasterTier: 'Nuevo cómic disponible AHORA para Master Tier',
    promoLimitedAccess: 'acceso limitado',
    promoPublicRelease: 'Lanzamiento público el próximo mes',
    promoSeeItNow: '¿Quieres verlo ahora?',
    bannerTodorokiText: 'Nuevo cómic mensual, sólo disponible para los miembros de la Tier Master.',
    bannerUnderfootText: 'Nuevo cómic original en proceso — una nueva aventura está a punto de comenzar en Footparadise.',
    bannerTanjiroText: 'Mayo en Patreon — Tanjiro enfrenta un desafío diferente a cualquier demonio que haya combatido. 🔥',
    bannerKidText: 'Mayo en Patreon — Eustass Kid finalmente consigue su trofeo. Un capitán pirata siempre obtiene lo que quiere. ⚡',
    bannerCellText: 'Mayo en Patreon — Cell ha estado ocultando su verdadero ser todo este tiempo. Ha llegado la hora de revelarlo. 💪',
    bannerMogariText: 'Mayo en Patreon — Mogari de Phantom Busters hace su debut. ¡Nació un nuevo favorito! 👻',
    bannerTaiyoText: 'Mayo en Patreon — Taiyo de la familia Yozakura tiene ganas de jugar. ¡No lo hagas esperar! 🌸',
    bannerLangrisText: 'Mayo en Patreon — El rey está en su trono y tiene una recompensa muy especial esperándote. 👑',
    bannerPromo1Text: 'Ya en Patreon — El cómic que lo inició todo. Nakamura y Hirose, nuestro primer lanzamiento, disponible ahora para miembros Master Tier. 🎓',
    bannerPromo2Text: 'Ya en Patreon — My Hero Academia, capítulo 4 y gran final. La primera parte del último capítulo ya está aquí. ¡Solo Master Tier! 💥',
    comicLibrary: '📚 Biblioteca de Cómics',
    searchComics: 'Buscar cómics...',
    browseCollection: 'Explora nuestra colección completa. ¡Puntúa cada cómic y mira los mejores en Top Rated!',
    topRated: '🏆 Mejor Puntuados',
    topRatedDescription: 'Los favoritos de nuestra comunidad',
    beFirstToRate: '¡Sé el primero en votar!',
    tapToRefresh: 'Toca para actualizar',
    unlock: 'DESBLOQUEAR',
    unlocked: '¡DESBLOQUEADO!',
    buy: 'Comprar',
    free: 'Gratis',
    readFree: 'Leer gratis',
    enterCode: 'Ingresar código',
    incorrectCode: 'Código incorrecto',
    ok: 'OK',
    lockAllConfirm: '¿Estás seguro de que quieres bloquear todos los cómics? Necesitarás ingresar el código de desbloqueo nuevamente.',
    // Menu
    myCollection: 'Mi Colección',
    news: 'Noticias',
    readOnPC: 'Leer en PC',
    backup: 'Respaldo',
    patreon: 'Patreon',
    store: 'Tienda',
    storeLoadError: 'No se pudo cargar la tienda',
    storeLoadErrorDesc: 'La tienda no se pudo cargar. Intenta abrirla en tu navegador.',
    openInBrowser: 'Abrir en Navegador',
    loading: 'Cargando',
    // Patreon Page
    visitPatreon: 'Visita Nuestro Patreon',
    patreonDescription: '¡Apóyanos en Patreon para obtener contenido exclusivo, acceso anticipado a nuevos cómics y actualizaciones detrás de escenas!',
    openPatreon: 'Abrir Patreon',
    exclusiveComics: 'Cómics Exclusivos',
    earlyAccess: 'Acceso Anticipado',
    community: 'Comunidad',
    specialRewards: 'Recompensas Especiales',
    patreonNote: 'Toca el botón de arriba para visitar nuestra página de Patreon',
    commissions: 'Comisiones',
    updates: 'Actualizaciones',
    infoCredits: 'Info y Créditos',
    signOut: 'Cerrar Sesión',
    // My Collection Page
    noComicsYet: 'Sin Cómics Aún',
    noComicsDescription: '¡Aún no has desbloqueado ningún cómic! Vuelve a la pantalla principal y desbloquea algunos cómics para verlos aquí.',
    browseComics: 'Explorar Cómics',
    yourUnlockedComics: '✨ Tus Cómics Desbloqueados ✨',
    comicsInCollection: 'cómic(s) en tu colección',
    pages: 'páginas',
    readNow: 'Leer Ahora',
    // Comic Viewer
    comicNotFound: 'Cómic no encontrado',
    comicNotFoundDesc: 'El cómic que buscas no existe',
    comicLocked: 'Cómic Bloqueado',
    comicLockedDesc: 'Debes desbloquear este cómic para verlo',
    backToHome: 'Volver al inicio',
    close: 'Cerrar',
    prev: '← Anterior',
    next: 'Siguiente →',
    // Backup Page
    backupRestore: 'Respaldo y Restauración',
    yourUnlockedComicsBackup: 'Tus Cómics Desbloqueados',
    backupDescription: 'Exporta tu lista de cómics desbloqueados para guardarla, o importa un respaldo para restaurar tu colección.',
    backupWarning: 'El respaldo solo guarda qué cómics has desbloqueado, no los cómics en sí.',
    export: 'Exportar',
    import: 'Importar',
    saving: 'Guardando...',
    backupSavedDownloads: '✅ ¡Respaldo guardado en la carpeta Descargas!',
    backupSavedDocuments: '✅ ¡Respaldo guardado en la carpeta Documentos!',
    backupSavedApp: '✅ ¡Respaldo guardado! Revisa la carpeta de la app.',
    backupSavedSuccess: '✅ ¡Respaldo guardado exitosamente!',
    backupExported: '✅ ¡Respaldo exportado exitosamente!',
    backupError: '❌ Error al exportar respaldo: ',
    restoredComics: '✅ ¡Cómic(s) restaurado(s)!',
    invalidBackup: '❌ Formato de archivo de respaldo inválido',
    couldNotReadBackup: '❌ No se pudo leer el archivo de respaldo',
    importError: '❌ Error al importar respaldo',
    backupHint: '📁 El respaldo se guardará en tu carpeta de Descargas',
    // Commissions Gallery
    commissionsCompleted: 'Comisiones Completadas',
    commissionsGallerySubtitle: 'Una muestra de ilustraciones personalizadas creadas para nuestros clientes. ¡Cada pieza representa una visión única hecha realidad!',
    filterAll: 'Todas',
    filterIllustration: 'Ilustraciones',
    totalCommissions: 'Total de obras',
    // Read on PC Page
    howToReadOnPC: 'Cómo Leer en PC',
    localServerMode: 'Modo Servidor Local - ¡No requiere internet!',
    step1: 'Asegúrate de que tu teléfono y computadora estén en la misma red Wi-Fi',
    step2: 'Toca Iniciar abajo para habilitar el acceso desde PC',
    step3: 'Abre el enlace que aparece abajo en el navegador de tu computadora',
    step4: '¡Disfruta tus cómics en una pantalla más grande!',
    pcImportant: 'Importante:',
    pcKeepOpen: 'Mantén esta app abierta mientras lees en tu PC. La conexión se perderá si cierras la app.',
    pcReaderActive: 'Lector de PC Activo',
    openURLOnPC: 'Abre esta URL en tu PC:',
    comicsAvailable: 'cómic(s) disponible(s)',
    noComicsUnlocked: 'Aún no has desbloqueado ningún cómic. Desbloquea algunos cómics primero para leerlos en PC.',
    disconnect: 'Desconectar',
    pleaseWait: 'Por favor espera...',
    disconnectHint: 'Toca "Desconectar" cuando termines de leer',
    // Info & Credits Page
    premiumCollection: 'Colección Premium de Arte Cómic',
    aboutUs: 'Sobre Nosotros',
    aboutUsText: '¡Bienvenido a FootParadise! Somos un equipo apasionado de artistas dedicados a crear contenido de cómics único y de alta calidad para nuestra increíble comunidad. Nuestra misión es traerte arte exclusivo e historias que no encontrarás en ningún otro lugar.',
    connectWithUs: 'Conéctate Con Nosotros',
    connectText: '¡Mantente actualizado con nuestros últimos lanzamientos, contenido detrás de escenas y anuncios exclusivos siguiéndonos en redes sociales!',
    officialWebsite: 'Página Web Oficial',
    support: 'Apoyo',
    supportText: '¿Te gusta nuestro trabajo? ¡Considera apoyarnos en Patreon para obtener acceso anticipado a nuevos cómics, contenido exclusivo y ayudarnos a seguir creando arte increíble para ti!',
    credits: 'Créditos',
    artStory: 'Arte e Historia',
    appDevelopment: 'Desarrollo de App',
    allRightsReserved: 'Todos los derechos reservados.',
    // Commissions Page
    customArtwork: 'Arte Personalizado',
    commissionsAccepted: '¡Se aceptan comisiones de cómics e ilustraciones! Obtén tu propia obra de arte personalizada.',
    askWithoutCommitment: 'Siéntete libre de preguntar sin compromiso de compra.',
    selectCommissionType: 'Selecciona el Tipo de Comisión',
    comic: 'Cómic',
    illustration: 'Ilustración',
    numberOfCharacters: 'Número de Personajes',
    details: 'Detalles',
    comicPlaceholder: 'Describe tu cómic: historia, personajes, número de páginas, preferencias de estilo, etc.',
    illustrationPlaceholder: 'Describe tu ilustración: personajes, poses, escenario, referencias, etc.',
    patreonUsername: 'Usuario de Patreon (Solo Master tier - 20% OFF)',
    patreonUsernamePlaceholder: 'Tu usuario de Patreon (opcional)',
    masterTierDiscount: '¡20% OFF para Patreon Master tier!',
    comicNoDiscount: 'Los cómics no aplican para el descuento de Patreon',
    yourContactEmail: 'Tu Email de Contacto',
    emailPlaceholder: 'tu.email@ejemplo.com',
    openingEmail: 'Abriendo Email...',
    sendCommissionRequest: 'Enviar Solicitud de Comisión',
    emailDisclaimer: 'Esto abrirá tu app de email con los detalles de la comisión pre-llenados.',
    pleaseSelectType: 'Por favor selecciona un tipo de comisión',
    pleaseProvideDetails: 'Por favor proporciona detalles para tu comisión',
    pleaseProvideEmail: 'Por favor proporciona tu email de contacto',
    sending: 'Enviando...',
    messageSentSuccess: '¡Mensaje enviado exitosamente! Te contactaremos pronto.',
    messageSentError: 'Error al enviar el mensaje. Por favor intenta de nuevo.',
    formspreeDisclaimer: 'Tu mensaje será enviado directamente a nuestro equipo.',
    // App Updates Page
    appUpdatesTitle: 'Actualizaciones de la App',
    downloadLatest: 'Descargar Última Versión',
    downloadAPK: 'Descargar APK',
    downloadApp: 'Descargar App',
    downloading: 'Descargando...',
    appUpdatesDescription: 'Descarga nuestra app exclusiva para acceder a todo el contenido, recibir notificaciones sobre nuevos cómics y disfrutar de una experiencia fluida en tu dispositivo móvil.',
    // News Page
    pullToRefresh: 'Desliza para actualizar',
    releaseToRefresh: 'Suelta para actualizar',
    loadingImages: 'Cargando imágenes...',
    loadingUpdates: 'Cargando novedades...',
    loadingLargeImages: 'Cargando imágenes grandes, por favor espera...',
    wifiTip: 'Consejo: Una buena conexión WiFi ayuda a cargar más rápido',
    gettingContent: 'Obteniendo el contenido más reciente para ti',
    // Settings Page
    settings: 'Configuración',
    language: 'Idioma',
    languageDescription: 'Elige tu idioma preferido para la interfaz de la app.',
    visual: 'Visual',
    visualDescription: 'Personaliza la apariencia de la app.',
    darkMode: 'Modo Oscuro',
    discreteMode: 'Modo Discreto',
    discreteModeHint: 'Difuminar portadas de cómics',
    sound: 'Sonido',
    soundDescription: 'Activa o desactiva los efectos de sonido en la app.',
    soundOn: 'Sonido Activado',
    soundOff: 'Sonido Desactivado',
    // Security
    security: 'Seguridad',
    securityDescription: 'Protege tu app con PIN o huella dactilar.',
    pinHint: 'Código de seguridad de 4 dígitos',
    biometric: 'Huella Dactilar',
    biometricHint: 'Usar huella para desbloquear',
    lockOptions: 'Opciones de Bloqueo',
    lockOnOpen: 'Bloquear al abrir la app',
    lockAfterInactivity: 'Bloquear tras inactividad',
    inactivityMinutes: 'Minutos de inactividad',
    createPin: 'Crear PIN',
    confirmPin: 'Confirmar PIN',
    enterNewPin: 'Ingresa un PIN de 4 dígitos',
    reenterPin: 'Reingresa tu PIN para confirmar',
    pinMismatch: 'Los PIN no coinciden',
    back: 'Volver',
    enterPinToUnlock: 'Ingresa tu PIN para desbloquear',
    incorrectPin: 'PIN incorrecto',
    useBiometric: 'Usar huella dactilar',
    biometricReason: 'Verifica tu identidad',
    biometricSubtitle: 'Usa tu huella para desbloquear',
    biometricSetup: 'Verifica para activar la huella',
    forgotPin: '¿Olvidaste tu PIN?',
    resetApp: 'Restablecer App',
    resetWarning: 'Esto eliminará TODOS tus datos incluyendo cómics desbloqueados, configuración y tu PIN. ¡Esta acción no se puede deshacer!',
    typeDeleteConfirm: 'Escribe BORRAR para confirmar:',
    typeDeleteToConfirm: 'Escribe BORRAR para confirmar',
    verifyPin: 'Verificar PIN',
    enterCurrentPin: 'Ingresa tu PIN actual para desactivar la seguridad',
    // Master Access
    advancedAccess: 'Acceso Avanzado',
    masterOnlyText: 'Esta opción es solo para miembros Master activos.',
    cancel: 'Cancelar',
    continue: 'Continuar',
    enterMasterCode: 'Ingresar Código Master',
    activate: 'Activar',
    accessGranted: '¡Acceso Concedido!',
    allComicsUnlocked: 'Todos los cómics han sido desbloqueados.',
    invalidCode: 'Código inválido. Por favor intenta de nuevo.',
    // Free Comics Section
    freeComicsSection: 'Vegeta: The paradise in his feet',
    freeComicsDescription: '¡Disfruta estos cómics gratis! No necesitas código. (Solo en inglés)',
    readFree: 'Leer Gratis'
  }
};

export const getTranslation = (language, key) => {
  return translations[language]?.[key] || translations['en'][key] || key;
};
